<template>
    <div>
        <v-overlay :value="loadingCompaniesList">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="col-item" flat style="border-top: 1px solid lightgray">
            <v-data-table
                :headers="tableHeaders"
                class="countries-table"
                dense
                :items="this.companies"
                :items-per-page="100"
                :footer-props="footerProps"
            >
                <template v-slot:item="{ item }">
                    <tr
                        :key="'company_' + item.id"
                        @click="handleTableRowClick(item)"
                        :class="{ activeTableRow: activeCompany && parseInt(item.id) === parseInt(activeCompany.id) }"
                    >
                        <td>{{ item.id }}</td>
                        <td>
                            {{
                                item.legal_type
                                    ? item.legal_type.charAt(0).toUpperCase() + item.legal_type.slice(1)
                                    : "-"
                            }}
                        </td>
                        <td>{{ item.name }}</td>
                        <td style="text-align: left">{{ item.identification_code }}</td>
                        <td style="text-align: end">{{ item.country }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <v-navigation-drawer :value="drawerOpen" fixed right hide-overlay width="900">
            <company-view v-if="$route.name === 'company-view'" />
            <company-edit v-if="$route.name === 'company-edit'" />
        </v-navigation-drawer>
    </div>
</template>
<script>
import Store from "@/store";
import { mapState } from "vuex";
import CompanyView from "./company-view";
import CompanyEdit from "./company-edit";
import router from "@/router";
export default {
    name: "companies-list",
    components: { CompanyView, CompanyEdit },
    data() {
        return {
            tableHeaders: [
                {
                    text: "ID",
                    align: "left",
                    value: "id"
                },
                {
                    text: this.t("Legal type"),
                    align: "left",
                    value: "legal_type"
                },
                {
                    text: this.t("Name"),
                    align: "left",
                    value: "name"
                },
                {
                    text: this.t("Identification code"),
                    align: "left",
                    value: "identification_code"
                },
                {
                    text: this.t("Country"),
                    align: "end",
                    value: "country"
                }
            ],
            footerProps: { "items-per-page-options": [25, 50, 100, 500] },
            mainDrawerOpen: null
        };
    },
    computed: {
        ...mapState([
            "user",
            "companies",
            "drawerOpen",
            "requestError",
            "errorMessage",
            "requestSuccess",
            "activeCompany",
            "loadingCompaniesList"
        ])
    },
    mounted() {
        if (this.user.role === "admin") {
            Store.dispatch("getCompanies");
            document.addEventListener("keydown", this.handleKeyboardListener);
            const drawerState = localStorage.getItem("mainDrawerOpen");
            if (drawerState) {
                this.mainDrawerOpen = JSON.parse(drawerState);
            } else {
                this.mainDrawerOpen = true;
            }
        } else {
            router.push("/admin/landing");
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    methods: {
        handleTableRowClick(company) {
            if (this.$route.name !== "company-view") {
                this.$router.push({ name: "company-view", params: { companyId: company.id } });
                return;
            }
            if (
                this.$route.name === "company-view" &&
                parseInt(company.id) !== parseInt(this.$route.params.companyId)
            ) {
                this.$router.push({ name: "company-view", params: { companyId: company.id } });
                Store.dispatch("getCompanyData", company.id);
            }
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 27 && this.drawerOpen) {
                this.$router.push({ name: "companies-list" });
            }
            if (
                this.activeCompany &&
                Object.keys(this.activeCompany).length > 0 &&
                this.activeCompany.id !== "new" &&
                this.$route.name !== "company-edit"
            ) {
                let currentProductIndex = this.companies.findIndex(p => p.id === this.activeCompany.id);
                if (e.key === "ArrowUp") {
                    if (currentProductIndex !== 0) {
                        const newCompanyId = this.companies[currentProductIndex - 1].id;
                        Store.dispatch("getCompanyData", newCompanyId);
                        this.$router.push({ name: this.$route.name, params: { companyId: newCompanyId } });
                    }
                } else if (e.key === "ArrowDown") {
                    if (currentProductIndex + 1 !== this.companies.length) {
                        const newCompanyId = this.companies[currentProductIndex + 1].id;
                        Store.dispatch("getCompanyData", newCompanyId);
                        this.$router.push({ name: this.$route.name, params: { companyId: newCompanyId } });
                    }
                }
            }
        }
    }
};
</script>
<style scoped>
.activeTableRow {
    background-color: #707070;
    color: #fff;
}
.activeTableRow:hover {
    background-color: #8d8d8d !important;
    color: #fff !important;
}
</style>
